module.exports = __webpack_public_path__ + "static/media/woman-notebook.e1476ca1.png";